module.exports = __webpack_public_path__ + "img/Sean.fa1f476e.jpeg";